import { Pipe, PipeTransform } from '@angular/core';

import { CoverageTerm } from '@amfam/policy/models';

@Pipe({
  name: 'perPersonFirst',
  standalone: false
})
export class PerPersonFirstPipe implements PipeTransform {
  transform(value: CoverageTerm[]): CoverageTerm[] {
    if (!Array.isArray(value)) {
      return value;
    }

    return value.sort(this.sortPerPersonFirst);
  }

  private sortPerPersonFirst(a: CoverageTerm, b: CoverageTerm): number {
    const isAPerPerson = a?.description?.includes('Per Person');
    const isBPerPerson = b?.description?.includes('Per Person');

    if (isAPerPerson && !isBPerPerson) {
      return -1; // a comes before b
    }
    if (!isAPerPerson && isBPerPerson) {
      return 1; // b comes before a
    }
    return 0; // keep original order if both or neither are 'Per Person'
  }
}
